import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
Vue.config.productionTip = false
//============in-built plugins===============

import VueFeather from 'vue-feather';
Vue.use(VueFeather);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// import DatePicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
Vue.component('datepicker', DatePicker)
Vue.component('date-picker', DatePicker)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import Paginate from 'vuejs-paginate';
Vue.component('paginate', Paginate);

import Notifications from 'vue-notification'
Vue.use(Notifications)


Vue.use(require('vue-moment'));

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.$cookies.config('7d', '', '', true)
//=================import mixins=================================
// import commonAllmixins from './plugins/commonAll/index.ts';
// Vue.mixin(commonAllmixins);

import giniMixins from './plugins/Gini/index.ts';
Vue.mixin(giniMixins);

//=================import env variable===========================
Vue.prototype.$env_var = process.env
import * as moment from 'moment'
//===================import components ===========================
import loader from './components/website/shared/loader'
Vue.component('loader', loader)
import table_loader from './components/website/shared/table_loader'
Vue.component('table-loader', table_loader)
import no_record from '@/components/website/shared/no_record'
Vue.component('no-record', no_record)

import password_icon from './components/website/shared/password_icon'
Vue.component('passwordIcon', password_icon)
import pagination from './components/website/shared/pagination'
Vue.component('app-pagination', pagination)
    //===============================================================
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js